function Actions() {
	return <div id="expected-hours-drawer" />;
}

export default Actions;
